import { MakeoverEngine, MakeoverQuality } from "../../../@types/sharedSchema";

/** Engine (performance tier) options offered in the picker, cheapest → best. Each has an
 *  emoji shown in the picker and as a tiny badge on the generated makeover tile.
 *  "value" is no longer offered — it was merged into "standard" (see resolveMakeoverEngine). */
export const MAKEOVER_ENGINE_OPTIONS: {
  key: MakeoverEngine;
  icon: string;
  labelKey: string;
  labelDefault: string;
  descKey: string;
  descDefault: string;
}[] = [
  {
    key: "standard",
    icon: "⭐",
    labelKey: "makeovers.engine.standard",
    labelDefault: "רגיל",
    descKey: "makeovers.engine.standardDesc",
    descDefault: "תוצאה איכותית ונאמנה למקור, במחיר הנמוך ביותר."
  },
  {
    key: "premium",
    icon: "👑",
    labelKey: "makeovers.engine.premium",
    labelDefault: "הכי חזק",
    descKey: "makeovers.engine.premiumDesc",
    descDefault: "התוצאה הטובה ביותר — המנוע המתקדם שלנו."
  }
];

// Makeovers made before the merge still carry "value" — keep their badge.
const ENGINE_ICONS: Record<MakeoverEngine, string> = { value: "🌱", standard: "⭐", premium: "👑" };

/** Emoji for an engine (empty string when unknown / not recorded on an old makeover). */
export const getMakeoverEngineIcon = (engine?: MakeoverEngine): string =>
  (engine && ENGINE_ICONS[engine]) ?? "";

/** Output resolution options. */
export const MAKEOVER_QUALITY_OPTIONS: {
  key: MakeoverQuality;
  labelKey: string;
  labelDefault: string;
}[] = [
  { key: "1K", labelKey: "makeovers.quality.standard", labelDefault: "רגיל (1K)" },
  { key: "2K", labelKey: "makeovers.quality.high", labelDefault: "רזולוציה גבוהה (2K)" }
];
